<div class="work-card no-padding margin-bottom-16">
  <div class="inline-padding">
    <h3>{{ 'FERIEN_SALDO' | translate }}</h3>
  </div>
  <ul class="work-list">
    <li>
      <p><small class="work-text-color-light">{{ 'SALDO_UEBERTRAG' | translate }} {{ balance().year - 1 }}</small></p>
      <p>{{ balance().transferredHolidaybalanceFromYearBefore | number:'1.1-1' }}</p>
    </li>
    <hr>
    <li>
      <p><small class="work-text-color-light">{{ 'FERIEN_GUTHABEN' | translate }} {{ balance().year }}</small></p>
      <p>{{ balance().targetHolidaybalanceForCurrentYear | number:'1.1-1' }}</p>
    </li>
    <li>
      <p><small class="work-text-color-light">{{ 'BEZOGEN_GEPLANT' | translate }} {{ balance().year }}</small></p>
      <p>{{ balance().actualHolidaybalanceForCurrentYear | number:'1.1-1' }}</p>
    </li>
    <li>
      <p><small class="work-text-color-light">{{ 'REST' | translate }} {{ balance().year }}</small></p>
      <p>{{ balance().currentHolidaybalanceSaldo | number:'1.1-1' }}</p>
    </li>
    <hr>
    <li>
      <p><small class="work-text-color-light">{{ 'SALDO_UEBERTRAG' | translate }} {{ balance().year + 1 }}</small></p>
      <p>{{ balance().transferringHolidaybalanceSaldoForNextYear | number:'1.1-1' }}</p>
    </li>
  </ul>
</div>
